<!-- Form principale - sempre visibile -->
<app-contact-edit-form 
  (onSubmit)="submit($event)" 
  [parentComponent]="this">
</app-contact-edit-form>

<!-- Sezioni master-detail - solo in edit -->
<ng-container *ngIf="enableMasterDetail">

  <!-- 1. Contact Information (Email, Telefono, Fax, PEC, ecc.) -->
  <div class="ct-manager-master-detail-container">
    <app-contact-information 
      #contactInformationComponent 
      [masterConfiguration]="configuration" 
      [parentComponent]="this">
    </app-contact-information>
  </div>

  <!-- 2. Contact Places (Sedi/luoghi) -->
  <div class="ct-manager-master-detail-container">
    <app-contact-place-list 
      #contactPlaceListComponent 
      [masterConfiguration]="configuration" 
      [parentComponent]="this">
    </app-contact-place-list>
  </div>

  <!-- 3. Company Contact (Relazioni con le company) -->
  <div class="ct-manager-master-detail-container">
    <app-company-contact
      *ngIf="companyContactConfiguration"
      [configuration]="companyContactConfiguration"
      [title]="'contact.references'">
    </app-company-contact>
  </div>

  <!-- 4. Contact Fee (Tariffe, se abilitato) -->
  <ng-container *ngIf="contactFeeConfiguration.visible">
    <div class="ct-manager-master-detail-container">
      <contact-fee 
        *ngIf="contactFeeConfiguration" 
        [configuration]="contactFeeConfiguration">
      </contact-fee>
    </div>
  </ng-container>

</ng-container>
